// @flow

import { useTranslation } from 'react-i18next';

// Styles
import styles from './index.module.sass';

const location = process.env.REACT_APP_COUNTRY;

type Props = {
  node: Object,
  setCatselected: any,
  catSelected: String,
  itemId: Number,
  open: String,
  setOpen: Function,
  history: Object,
  match: Object,
};

export default function MenuItem({
  node,
  setCatselected,
  itemId,
  open,
  setOpen,
  catSelected,
  history,
  match,
  screenSize,
}: Props): React$Node {
  const { descri = '', subcateg = [], descEN = '', descES = '' } = node;

  const { i18n = {} } = useTranslation();
  const { language = '' } = i18n;

  const category =
    (location === 'MX' && descri.toLowerCase()) || (language.includes('es') && descES) || descEN;

  function handleClick() {
    const thisOpen = open === itemId ? '' : itemId;
    setOpen(thisOpen);
  }

  function handleSubCat(subCat, subName) {
    window.scrollTo(0, 0);
    const parent = (location === 'MX' && descri.toLowerCase()) || descEN;
    history.push(
      `${match.path}/${parent.toLowerCase().replace(/ /g, '-')}/${subName
        .toLowerCase()
        .replace(/ /g, '-')}`,
    );
    setCatselected(subCat);
  }
  return (
    <div className={`${styles.menuItem} ${styles[screenSize]}`}>
      <div className={`${styles.item} ${styles[open === itemId]}`} onClick={handleClick}>
        <span>{category.charAt(0).toUpperCase() + category.slice(1)}</span>
        <i className={`material-icons `}>navigate_next</i>
      </div>
      <div className={`${styles.subitems} ${styles[open === itemId]}`}>
        {subcateg.map((val, key) => {
          const { descri = '', descriES = '', descriEN = '', numero, imagen } = val;
          const subCategory =
            (location === 'MX' && descri.toLowerCase()) ||
            (language.includes('es') && descriES.toLowerCase()) ||
            descriEN.toLowerCase();
          return (
            <div
              className={`${styles[catSelected === numero]} ${styles.subitem}`}
              key={key}
              onClick={() => handleSubCat(numero, (location === 'MX' && descri) || descriEN)}>
              <div
                className={styles.sectionImage}
                style={{
                  //backgroundImage: `url(https://webimages.terramarbrands.com.mx/shopping-cart/sections/${numero}.png)`,
                  backgroundImage: `url(${imagen})`,
                }}></div>
              <span className={styles.sectionName}>
                {subCategory.charAt(0).toUpperCase() + subCategory.slice(1)}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
